import AnimatedCard from "./AnimatedCard";
import getYouTubeEmbedUrl from "../utils/videoUrlExtractor";
import { Icon } from "@iconify/react";
import AnimatedFeatureCards from "./AnimatedFeatureCard";

export default function PersonalTutorSection() {
  const videoLink = "https://youtu.be/foJAHEmZebg"

  return (
    <section className="py-16 px-4 ">

      <div className="max-w-screen-xl mx-auto">
        <div className="text-center mb-16 ">
          <AnimatedCard direction="fadeIn" duration={0.8} once={true} className="flex flex-col items-center justify-center gap-4">
            <p className="text-primary-purple-400">Bildup AI - Your Child's Personal AI Tutor</p>
            <h2 className="text-[24px] md:text-[48px] md:flex md:flex-col gap-4 mb-4  ">
              Helping Your Child Learn and Grow <br className="hidden md:block" /> <span className="">with Confidence</span>
            </h2>
            <p className="text-lg text-gray-500 max-w-2xl mx-auto">
              With Bildup AI, your child gets structured learning support, real-time progress tracking, and expert guidance all in a safe and engaging environment. Stay informed, set goals, and watch your child thrive.
            </p>
          </AnimatedCard>
        </div>

        <div className="flex flex-col gap-16">

            <div className="h-[70vh] relative overflow-hidden rounded-2xl">
                {videoLink.includes('youtu') ? (
                    // YouTube embed - fixed height approach
                    <div className="w-full h-full">
                        <iframe 
                            src={`${getYouTubeEmbedUrl(videoLink)}?autoplay=0&rel=0&modestbranding=1&mute=1`}
                            className="w-full h-full object-cover"
                            title={"PersonalTutorSection"}
                            frameBorder="0"
                            loading="lazy"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                            allowFullScreen
                        ></iframe>
                    </div>
                ) : (
                    // Regular video
                    <video 
                        src={videoLink} 
                        className="w-full h-full object-cover"
                        autoPlay
                        muted
                        loop
                        playsInline
                    />
                )}
            </div>

            <AnimatedFeatureCards/>
         

        </div>


      </div>
    </section>
  );
}
